import content from "../../data/content";
import SectionDivider from "../../components/SectionDivider";
import CtaBanner from "../../components/CtaBanner";
import "./About.css";

const { about } = content;

function TextWithBreaks({ text }) {
  return text.split("\n").map((line, i, arr) => (
    <span key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </span>
  ));
}

export default function About() {
  return (
    <div className="about-page">
      <section className="about-header">
        <p className="page-label">About Us</p>
        <h1 className="page-heading">品牌介紹</h1>
      </section>

      {/* ---- Founder ---- */}
      <section className="about-section">
        <div className="about-section__inner">
          <p className="section-label">{about.founder.sectionLabel}</p>

          <div className="about-founder__photo-wrap">
            <img
              src={about.founder.image}
              alt={about.founder.name}
              className="about-founder__photo"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
            <div className="about-founder__photo-placeholder img-placeholder" style={{ display: "none" }}>
              Photo
            </div>
          </div>

          <h2 className="about-founder__name">{about.founder.name}</h2>
          <div className="about-founder__bio">
            {about.founder.bio.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </section>

      <SectionDivider />

      {/* ---- Credentials ---- */}
      <section className="about-section">
        <div className="about-section__inner">
          <p className="section-label">{about.credentials.sectionLabel}</p>
          <ul className="about-credentials">
            {about.credentials.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <SectionDivider />

      {/* ---- Manifesto ---- */}
      <section className="about-section about-manifesto">
        <div className="about-section__inner">
          <p className="section-label">{about.manifesto.sectionLabel}</p>
          {about.manifesto.blocks.map((block, i) => (
            <div key={i} className="about-manifesto__block">
              {block.heading && (
                <h3 className="about-manifesto__heading">{block.heading}</h3>
              )}
              <p className="about-manifesto__body">
                <TextWithBreaks text={block.body} />
              </p>
            </div>
          ))}
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
